import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { CardIconProps } from '../types/interfaces'
import type { BrandShapeIconColor } from '@UI/Brand/BrandShapeIcon'

const BRAND_PLATE_SURFACES: readonly BrandShapeIconColor[] = ['ultraviolet', 'orange', 'pink', 'sky', 'sunshine', 'green']

const isBrandPlateSurface = (surface: string): surface is BrandShapeIconColor => (
  (BRAND_PLATE_SURFACES as readonly string[]).includes(surface)
)

interface CardIconHookOptions {
  props: CardIconProps
}

interface CardIconHookReturn {
  refPlateColor: ComputedRef<BrandShapeIconColor>
  refTitleClass: ComputedRef<string>
}

export const useCardIcon = ({ props }: CardIconHookOptions): CardIconHookReturn => {
  const refPlateColor = computed<BrandShapeIconColor>(() => {
    const surface = props.surface ?? 'white'
    return isBrandPlateSurface(surface) ? surface : (props.color ?? 'ultraviolet')
  })

  const refTitleClass = computed<string>(() => {
    if (props.layout !== 'vertical') return 'btly-text-title-xl'
    return props.desktopScaleFrom === 'desktop'
      ? 'btly-text-title-xl lg:btly-text-heading-s'
      : 'btly-text-title-xl md:btly-text-heading-s'
  })

  return {
    refPlateColor,
    refTitleClass,
  }
}
